export const forms = {
  PRODUCT: 'PRODUCT',
  CRM: 'CRM',
  INCEDENT: 'INCEDENT',
  BI: 'BI',
};

export const directions = {
  CRM: 'crm',
  INCEDENT: 'prod_incident',
  BI: 'bi',
};
